import { createContext } from 'use-context-selector';

export interface NotificationsContextProps {
  host?: string;
}

export const NotificationsContext = createContext<NotificationsContextProps>(
  {}
);
